import { useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import styles from './spendingData.module.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import dateFormatter from '../../../utils/dateFormatter'
import {
  expenseApi,
  useGetAllSpendingQuery,
} from '../../../features/api/expense/expenseApi'
import { SpendingFilter } from './SpendingFilter'
import { AddSpending } from './AddSpending'
export const SpendingData = () => {
  const [key, setKey] = useState('Expense List')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Pagination States
  const [pageNo, setPageNo] = useState(0)
  const [pageSize, setPageSize] = useState(30)
  const [totalPages, setTotalPages] = useState(null)
  const [expenses, setExpenses] = useState([])
  const [totalDisplayed, setTotalDisplayed] = useState(0)

  const spendingFilter = useSelector((state) => state.spendingFilter)

  // Fetching data from API
  const { data, isLoading, isError } = useGetAllSpendingQuery({
    page: pageNo,
    size: pageSize,
    ...spendingFilter,
  })

  // Function to fetch next page of products
  const getNextPage = (page) => {
    dispatch(
      expenseApi.endpoints.getAllSpending.initiate({
        page: pageNo,
        size: pageSize,
        ...spendingFilter,
      })
    )
  }

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setPageNo(newPage)
      getNextPage(newPage)
    }
  }

  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value)
    setPageSize(newSize)
    setPageNo(0) // Reset to first page when page size changes
  }

  // When data is fetched, update the products state
  useEffect(() => {
    if (data?.content) {
      setExpenses(data.content)
      setTotalPages(data.totalPages)
      calculateTotalDisplayed(data.content)
    }
  }, [data])
  useEffect(() => {
    setPageNo(0)
  }, [spendingFilter])

  const calculateTotalDisplayed = (data) => {
    let total = 0
    data?.forEach((element) => {
      total += element.amount
    })
    setTotalDisplayed(total)
  }
  return (
    <div className='container pt-5'>
      <Tabs
        id='controlled-tab'
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className='mb-3'
      >
        <Tab eventKey='Expense List' title='Expense List'>
          <SpendingFilter />
          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading expenses...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th className='text-center'>No</th>
                      <th className='text-center'>Amount (€)</th>
                      <th className='text-center'>Spent by</th>
                      <th className='text-center'>Payment method</th>
                      <th className='text-center'>Created at</th>
                      <th className='text-center'>Created by</th>
                      <th className='text-center'>Expense date</th>
                      <th className='text-center'>Category</th>
                      <th className='text-center'>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expenses.length > 0 ? (
                      <>
                        {expenses.map((expense, idx) => (
                          <tr
                            key={idx}
                            onClick={() => navigate(`/expense/${expense.id}`)}
                          >
                            <td className='text-center'>{expense.id}</td>
                            <td className='text-center'>
                              {expense.amount.toFixed(2)}
                            </td>
                            <td className='text-center'>{expense.spentBy}</td>
                            <td className='text-center'>
                              {expense.paymentMethod}
                            </td>
                            <td className='text-center'>
                              {dateFormatter(expense.createdAt)}
                            </td>
                            <td className='text-center'>{expense.createdBy}</td>
                            <td className='text-center'>
                              {dateFormatter(expense.expenseDate)}
                            </td>
                            <td className='text-center'>
                              {expense.spendingCategory}
                            </td>
                            <td className='text-center'>
                              {expense.description}
                            </td>
                          </tr>
                        ))}

                        {/* TOTAL FOOTER ROW */}
                        <tr className={styles.redHighlight}>
                          <td colSpan='9' className='text-start fw-bold'>
                            Total : {totalDisplayed.toFixed(2)}€
                          </td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan='9' className={styles.noData}>
                          No expense found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                <div className={styles.pagination}>
                  {/* Page Size Selector */}
                  <div className={styles.pageSizeSelector}>
                    <label htmlFor='pageSize'>Page Size: </label>
                    <select
                      id='pageSize'
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <button
                    onClick={() => handlePageChange(pageNo - 1)}
                    disabled={pageNo === 0}
                  >
                    Previous
                  </button>
                  <span>
                    Page {pageNo + 1} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(pageNo + 1)}
                    disabled={
                      !data?.content?.length || totalPages === pageNo + 1
                    }
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </Tab>

        <Tab eventKey='Add expense' title='Add expense'>
          <AddSpending onSuccess={() => setKey('Expense List')} />
        </Tab>
      </Tabs>
    </div>
  )
}
